<template>
  <header class="page__banner page--background">
    <el-container direction="vertical" class="page--container">
      <el-row>
        <el-col :sm="{span: 16, offset: 4}">
          <h1 :class="{light: true, center: centerHeader}">{{ heading }}</h1>
          <h2 :class="{h5: true, 'font-family-body': true, light: true, center: centerHeader}">{{ subHeading }}</h2>
        </el-col>
      </el-row>
    </el-container>
  </header>
</template>

<script>
  export default {
    name: 'PageBanner',
    props: [
      'heading',
      'subHeading',
      'centerHeader',
    ]
  }
</script>

<style>

.center {
 text-align: center;
}

</style>
